// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const MlHttpDeleteFaceRecognitionAssetsByAssetIdPersonsBulk =
  'MlHttpDeleteFaceRecognitionAssetsByAssetIdPersonsBulk' as const;
export const MlHttpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersons =
  'MlHttpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersons' as const;
export const MlHttpPostFaceRecognitionBulkExtract =
  'MlHttpPostFaceRecognitionBulkExtract' as const;
export const MlHttpPutFaceRecognitionChangePersonJobsState =
  'MlHttpPutFaceRecognitionChangePersonJobsState' as const;
export const MlHttpPostFaceRecognitionEmbeddingsReindex =
  'MlHttpPostFaceRecognitionEmbeddingsReindex' as const;
export const MlHttpPostFaceRecognitionEmbeddingsByEmbeddingIdReindex =
  'MlHttpPostFaceRecognitionEmbeddingsByEmbeddingIdReindex' as const;
export const MlHttpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionId =
  'MlHttpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionId' as const;
export const MlHttpPutFaceRecognitionJobsPriority =
  'MlHttpPutFaceRecognitionJobsPriority' as const;
export const MlHttpPutFaceRecognitionJobsState =
  'MlHttpPutFaceRecognitionJobsState' as const;
export const MlHttpGetFaceRecognitionPersons =
  'MlHttpGetFaceRecognitionPersons' as const;
export const MlHttpDeleteFaceRecognitionPersonsBulkDelete =
  'MlHttpDeleteFaceRecognitionPersonsBulkDelete' as const;
export const MlHttpPostFaceRecognitionPersonsReindex =
  'MlHttpPostFaceRecognitionPersonsReindex' as const;
export const MlHttpDeleteFaceRecognitionPersonsByPersonId =
  'MlHttpDeleteFaceRecognitionPersonsByPersonId' as const;
export const MlHttpGetFaceRecognitionPersonsByPersonId =
  'MlHttpGetFaceRecognitionPersonsByPersonId' as const;
export const MlHttpPatchFaceRecognitionPersonsByPersonId =
  'MlHttpPatchFaceRecognitionPersonsByPersonId' as const;
export const MlHttpPutFaceRecognitionPersonsByPersonId =
  'MlHttpPutFaceRecognitionPersonsByPersonId' as const;
export const MlHttpDeleteFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionId =
  'MlHttpDeleteFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionId' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdChangePerson =
  'MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdChangePerson' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPerson =
  'MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPerson' as const;
export const MlHttpDeleteFaceRecognitionPersonsByPersonIdBulk =
  'MlHttpDeleteFaceRecognitionPersonsByPersonIdBulk' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdConfirmPerson =
  'MlHttpPostFaceRecognitionPersonsByPersonIdConfirmPerson' as const;
export const MlHttpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrl =
  'MlHttpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrl' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdMergeByNewPersonId =
  'MlHttpPostFaceRecognitionPersonsByPersonIdMergeByNewPersonId' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdReindex =
  'MlHttpPostFaceRecognitionPersonsByPersonIdReindex' as const;
export const MlHttpPostFaceRecognitionPersonsByPersonIdUpdateAndConfirm =
  'MlHttpPostFaceRecognitionPersonsByPersonIdUpdateAndConfirm' as const;
export const MlHttpGetFaceRecognitionPersonsByPersonIdVersions =
  'MlHttpGetFaceRecognitionPersonsByPersonIdVersions' as const;

/**
 * Original schema `AssetVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-AssetVersionSchema}
 */
export interface MlAssetVersionSchema {
  asset_id?: string;
  face_ids?: string[];
  segment_count?: number;
  version_id?: string;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BaseQueryParamsSchema}
 */
export interface MlBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `BulkConfirmPersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkConfirmPersonSchema}
 */
export interface MlBulkConfirmPersonSchema {
  all_instances_except_unconfirmed?: boolean;
  version_ids?: string[] | null;
}
/**
 * Original schema `BulkDeletePersonsByIdsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkDeletePersonsByIdsSchema}
 */
export interface MlBulkDeletePersonsByIdsSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  person_ids: string[];
}
/**
 * Original schema `BulkDeletePersonsByVersionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkDeletePersonsByVersionsSchema}
 */
export interface MlBulkDeletePersonsByVersionsSchema {
  objects: MlDeletePersonByVersion[];
}
/**
 * Original schema `DeletePersonByVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-DeletePersonByVersion}
 */
export interface MlDeletePersonByVersion {
  person_id: string;
  version_id: string;
}
/**
 * Original schema `BulkDeletePersonsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkDeletePersonsSchema}
 */
export interface MlBulkDeletePersonsSchema {
  /**
   * @minItems 1
   * @maxItems 100
   */
  objects: MlDeletePerson[];
}
/**
 * Original schema `DeletePerson`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-DeletePerson}
 */
export interface MlDeletePerson {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `BulkFaceExtractSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkFaceExtractSchema}
 */
export interface MlBulkFaceExtractSchema {
  face_image_analysis_profile_id?: string;
  face_video_analysis_profile_id?: string;
  force?: boolean;
  include_assets?: boolean;
  include_collections?: boolean;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  object_type: 'assets' | 'collections' | 'saved_searches';
}
/**
 * Original schema `BulkPersonByAssetAndVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkPersonByAssetAndVersion}
 */
export interface MlBulkPersonByAssetAndVersion {
  persons?: MlPersonByAssetAndVersion[];
  version_id: string;
}
/**
 * Original schema `PersonByAssetAndVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersion}
 */
export interface MlPersonByAssetAndVersion {
  asset_id: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  version_id: string;
}
/**
 * Original schema `BulkPersonByAssetAndVersionListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkPersonByAssetAndVersionListSchema}
 */
export interface MlBulkPersonByAssetAndVersionListSchema {
  objects?: MlBulkPersonByAssetAndVersion[];
}
/**
 * Original schema `BulkPersonByAssetAndVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkPersonByAssetAndVersionSchema}
 */
export interface MlBulkPersonByAssetAndVersionSchema {
  persons?: MlPersonByAssetAndVersion[];
  version_id: string;
}
/**
 * Original schema `BulkReindexPersonsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-BulkReindexPersonsSchema}
 */
export interface MlBulkReindexPersonsSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  person_ids: string[];
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ChangePersonInstanceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ChangePersonInstanceSchema}
 */
export interface MlChangePersonInstanceSchema {
  new_person_id?: string | null;
  new_person_name?: string | null;
}
/**
 * Original schema `CheckPersonsStatusSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-CheckPersonsStatusSchema}
 */
export interface MlCheckPersonsStatusSchema {
  /**
   * @minItems 1
   * @maxItems 100
   */
  person_ids: string[];
}
/**
 * Original schema `CopyPersonsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-CopyPersonsSchema}
 */
export interface MlCopyPersonsSchema {
  source_asset_id: string;
  source_version_id: string;
  target_asset_id: string;
  target_version_id: string;
}
/**
 * Original schema `CreatePersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-CreatePersonSchema}
 */
export interface MlCreatePersonSchema {
  main_face_id?: string;
  name?: string | null;
}
/**
 * Original schema `DeletePersonByVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-DeletePersonByVersionSchema}
 */
export interface MlDeletePersonByVersionSchema {
  person_id: string;
  version_id: string;
}
/**
 * Original schema `DeletePersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-DeletePersonSchema}
 */
export interface MlDeletePersonSchema {
  asset_id: string;
  version_id: string;
}
/**
 * Original schema `EmbeddingBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-EmbeddingBaseSchema}
 */
export interface MlEmbeddingBaseSchema {
  date_created?: string;
  embedding_vector?: number[];
  type?: 'AUGMENTED' | 'NORMAL';
}
/**
 * Original schema `EmbeddingByFaceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-EmbeddingByFaceSchema}
 */
export interface MlEmbeddingByFaceSchema {
  date_created?: string;
  embedding_vector?: number[];
  face_id?: string;
  id?: string;
  system_domain_id?: string;
  type?: 'AUGMENTED' | 'NORMAL';
}
/**
 * Original schema `EmbeddingByPersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-EmbeddingByPersonSchema}
 */
export interface MlEmbeddingByPersonSchema {
  date_created?: string;
  embedding_vector?: number[];
  id?: string;
  person_id?: string;
  system_domain_id?: string;
  type?: 'AUGMENTED' | 'NORMAL';
}
/**
 * Original schema `EmbeddingByStatusSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-EmbeddingByStatusSchema}
 */
export interface MlEmbeddingByStatusSchema {
  date_created?: string;
  date_modified?: string;
  embedding_vector?: number[];
  id?: string;
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  type?: 'AUGMENTED' | 'NORMAL';
}
/**
 * Original schema `EmbeddingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-EmbeddingSchema}
 */
export interface MlEmbeddingSchema {
  date_created?: string;
  date_modified?: string;
  embedding_vector?: number[];
  id?: string;
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  type?: 'AUGMENTED' | 'NORMAL';
}
/**
 * Original schema `Face`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-Face}
 */
export interface MlFace {
  asset_id?: string;
  augmented_embedding_ids?: string[];
  bounding_box?: number[];
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  detection_probability?: number;
  directory_path?: string;
  embedding_id?: string;
  filename?: string;
  id?: string;
  image_url?: string;
  landmarks?: MlFaceLandmarkSchema[];
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  storage_id?: string;
  system_domain_id?: string;
  timestamp_ms?: number;
  version_id?: string;
}
/**
 * Original schema `FaceLandmarkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceLandmarkSchema}
 */
export interface MlFaceLandmarkSchema {
  x?: number;
  y?: number;
}
/**
 * Original schema `FaceBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceBaseSchema}
 */
export interface MlFaceBaseSchema {
  augmented_embedding_ids?: string[];
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  directory_path?: string;
  embedding_id?: string;
  filename?: string;
  image_url?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  storage_id?: string;
}
/**
 * Original schema `FaceByAssetAndVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceByAssetAndVersionSchema}
 */
export interface MlFaceByAssetAndVersionSchema {
  asset_id?: string;
  augmented_embedding_ids?: string[];
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  directory_path?: string;
  embedding_id?: string;
  filename?: string;
  id?: string;
  image_url?: string;
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  storage_id?: string;
  system_domain_id?: string;
  version_id?: string;
}
/**
 * Original schema `FaceByPersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceByPersonSchema}
 */
export interface MlFaceByPersonSchema {
  augmented_embedding_ids?: string[];
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  directory_path?: string;
  embedding_id?: string;
  filename?: string;
  id?: string;
  image_url?: string;
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  storage_id?: string;
  system_domain_id?: string;
}
/**
 * Original schema `FaceListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceListSchema}
 */
export interface MlFaceListSchema {
  objects?: MlFace[];
}
/**
 * Original schema `FaceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-FaceSchema}
 */
export interface MlFaceSchema {
  asset_id?: string;
  augmented_embedding_ids?: string[];
  bounding_box?: number[];
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  detection_probability?: number;
  directory_path?: string;
  embedding_id?: string;
  filename?: string;
  id?: string;
  image_url?: string;
  landmarks?: MlFaceLandmarkSchema[];
  person_id?: string;
  status?: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  storage_id?: string;
  system_domain_id?: string;
  timestamp_ms?: number;
  version_id?: string;
}
/**
 * Original schema `JobsPrioritySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-JobsPrioritySchema}
 */
export interface MlJobsPrioritySchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
  priority: number;
}
/**
 * Original schema `JobsStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-JobsStateSchema}
 */
export interface MlJobsStateSchema {
  action: 'RESTART' | 'ABORT';
  /**
   * @minItems 1
   * @maxItems 500
   */
  job_ids: string[];
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ListObjectsSchema}
 */
export interface MlListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `MLDetectionQueueRecordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-MLDetectionQueueRecordSchema}
 */
export interface MlMLDetectionQueueRecordSchema {
  bytes_params?: unknown;
  date_created?: string;
  date_updated?: string;
  id?: string;
  job_id: string;
  object_id?: string | null;
  object_type?: string | null;
  params?: string | null;
  parent_job_id?: string | null;
  priority?: number | null;
  retry_count?: number | null;
  spec?: string | null;
  status?: string | null;
  system_domain_id: string;
  system_name?: string;
  type?: string | null;
  user_id: string;
  version_id?: string | null;
}
/**
 * Original schema `Person`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-Person}
 */
export interface MlPerson {
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
}
/**
 * Original schema `PersonAssetsVersionsListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonAssetsVersionsListSchema}
 */
export interface MlPersonAssetsVersionsListSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: MlPersonByAssetAndVersionInAdmin[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `PersonByAssetAndVersionInAdmin`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionInAdmin}
 */
export interface MlPersonByAssetAndVersionInAdmin {
  asset_id: string;
  asset_title: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  version_id: string;
  version_number?: string;
}
/**
 * Original schema `PersonByAssetAndVersionInAdminSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionInAdminSchema}
 */
export interface MlPersonByAssetAndVersionInAdminSchema {
  asset_id: string;
  asset_title: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  version_id: string;
  version_number?: string;
}
/**
 * Original schema `PersonByAssetAndVersionListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionListSchema}
 */
export interface MlPersonByAssetAndVersionListSchema {
  objects?: MlPersonByAssetAndVersion[];
}
/**
 * Original schema `PersonByAssetAndVersionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionSchema}
 */
export interface MlPersonByAssetAndVersionSchema {
  asset_id: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
  version_id: string;
}
/**
 * Original schema `PersonInstancesQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonInstancesQueryParamsSchema}
 */
export interface MlPersonInstancesQueryParamsSchema {
  include_admin_details?: boolean;
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
  use_instance_as_main_face?: boolean;
}
/**
 * Original schema `PersonListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonListSchema}
 */
export interface MlPersonListSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: MlPerson[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  scroll_id?: string;
  total?: number;
}
/**
 * Original schema `PersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonSchema}
 */
export interface MlPersonSchema {
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string;
}
/**
 * Original schema `PersonsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonsQueryParamsSchema}
 */
export interface MlPersonsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  scroll?: boolean;
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `ReindexAllEmbeddingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ReindexAllEmbeddingsSchema}
 */
export interface MlReindexAllEmbeddingsSchema {
  embedding_ids?: string[] | null;
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexEmbeddingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ReindexEmbeddingSchema}
 */
export interface MlReindexEmbeddingSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexPersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ReindexPersonSchema}
 */
export interface MlReindexPersonSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexQueueRecordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-ReindexQueueRecordSchema}
 */
export interface MlReindexQueueRecordSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `URLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-URLSchema}
 */
export interface MlURLSchema {
  url?: string;
}
/**
 * Original schema `UpdateConfirmPersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-UpdateConfirmPersonSchema}
 */
export interface MlUpdateConfirmPersonSchema {
  all_instances_except_unconfirmed?: boolean;
  name: string;
  version_ids?: string[] | null;
}
/**
 * Original schema `UpdatePersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-UpdatePersonSchema}
 */
export interface MlUpdatePersonSchema {
  main_face_id?: string;
  name?: string | null;
}
/**
 * Original schema `VersionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-VersionsSchema}
 */
export interface MlVersionsSchema {
  asset_id: string;
  version_ids?: string[];
}
/**
 * Original schema `PersonByAssetAndVersionListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionListSchema}
 */
export interface MlPersonByAssetAndVersionListSchemaWithId {
  objects: MlPersonByAssetAndVersionNullable[];
}
/**
 * Original schema `PersonByAssetAndVersion`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersion}
 */
export interface MlPersonByAssetAndVersionNullable {
  asset_id: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string | null;
  version_id: string;
}
/**
 * Original schema `PersonListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonListSchema}
 */
export interface MlPersonListSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: MlPersonNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `Person`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-Person}
 */
export interface MlPersonNullable {
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string | null;
}
/**
 * Original schema `PersonSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonSchema}
 */
export interface MlPersonSchemaNullable {
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string | null;
}
/**
 * Original schema `URLSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-URLSchema}
 */
export interface MlURLSchemaNullable {
  url?: string | null;
}
/**
 * Original schema `PersonAssetsVersionsListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonAssetsVersionsListSchema}
 */
export interface MlPersonAssetsVersionsListSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: MlPersonByAssetAndVersionInAdminNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  scroll_id?: string;
  total: number;
}
/**
 * Original schema `PersonByAssetAndVersionInAdmin`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#model-PersonByAssetAndVersionInAdmin}
 */
export interface MlPersonByAssetAndVersionInAdminNullable {
  asset_id: string;
  asset_title: string;
  created_by_user: string | null;
  date_created: string;
  date_modified: string;
  has_unconfirmed_instances: boolean;
  id: string;
  image_url: string | null;
  main_face_id: string | null;
  name: string | null;
  person_version_face_id: string;
  person_version_face_image_url: string | null;
  status: 'NEW' | 'UNCONFIRMED' | 'SYSTEM_CONFIRMED' | 'USER_CONFIRMED';
  system_domain_id?: string | null;
  version_id: string;
  version_number?: string | null;
}

/**
 * `DELETE /v1/face_recognition/assets/{asset_id}/persons/bulk/`
 *
 * Delete all persons by asset and versions
 *
 * Required roles:
 *  - can_delete_person
 *
 * Responses
 * - 201 - Returns the definition of the created job of deleting persons
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/delete_v1_face_recognition_assets__asset_id__persons_bulk_}
 */
export const httpDeleteFaceRecognitionAssetsByAssetIdPersonsBulk = (
  assetId: string,
  body: MlBulkDeletePersonsByVersionsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpDeleteFaceRecognitionAssetsByAssetIdPersonsBulk,
  method: httpMethod.delete,
  url: `/API/ml/v1/face_recognition/assets/${encodeURIComponent(assetId)}/persons/bulk/`,
  params: { assetId },
  body,
  headers,
});

export interface MlHttpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersonsQuery {
  fetch_image_url?: boolean;
}

/**
 * `GET /v1/face_recognition/assets/{asset_id}/versions/{version_id}/persons/`
 *
 * List all persons associated with a specific asset version
 *
 * Required roles:
 *  - can_read_person
 *
 * Responses
 * - 200 - Returns a list of persons associated with the asset version
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MlPersonByAssetAndVersionListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/get_v1_face_recognition_assets__asset_id__versions__version_id__persons_}
 */
export const httpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersons = (
  assetId: string,
  versionId: string,
  query?: MlHttpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersonsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpGetFaceRecognitionAssetsByAssetIdVersionsByVersionIdPersons,
  method: httpMethod.get,
  url: `/API/ml/v1/face_recognition/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/persons/`,
  params: { assetId, versionId },
  query,
  headers,
});

/**
 * `POST /v1/face_recognition/bulk/extract/`
 *
 * Run face recognition in bulk for different object types
 *
 * Required roles:
 *  - can_trigger_face_recognition
 *
 * Responses
 * - 202 - Process started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Face recognition is not enabled for this system domain
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_bulk_extract_}
 */
export const httpPostFaceRecognitionBulkExtract = (
  body: MlBulkFaceExtractSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionBulkExtract,
  method: httpMethod.post,
  url: '/API/ml/v1/face_recognition/bulk/extract/',

  body,
  headers,
});

/**
 * `PUT /v1/face_recognition/change_person/jobs/state/`
 *
 * Abort Change Person job
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 200 - Job lock removed
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/put_v1_face_recognition_change_person_jobs_state_}
 */
export const httpPutFaceRecognitionChangePersonJobsState = (
  body: MlJobsStateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPutFaceRecognitionChangePersonJobsState,
  method: httpMethod.put,
  url: '/API/ml/v1/face_recognition/change_person/jobs/state/',

  body,
  headers,
});

/**
 * `POST /v1/face_recognition/embeddings/reindex/`
 *
 * Trigger reindexing of all embeddings
 *
 * Required roles:
 *  - can_reindex_person
 *
 * Responses
 * - 202 - Embeddings scheduled for reindexing
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_embeddings_reindex_}
 */
export const httpPostFaceRecognitionEmbeddingsReindex = (
  body: MlReindexAllEmbeddingsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionEmbeddingsReindex,
  method: httpMethod.post,
  url: '/API/ml/v1/face_recognition/embeddings/reindex/',

  body,
  headers,
});

/**
 * `POST /v1/face_recognition/embeddings/{embedding_id}/reindex/`
 *
 * Reindex embedding
 *
 * Required roles:
 *  - can_reindex_person
 *
 * Responses
 * - 202 - Embedding scheduled for reindexing
 * - 401 - Token is invalid
 * - 404 - embedding does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_embeddings__embedding_id__reindex_}
 */
export const httpPostFaceRecognitionEmbeddingsByEmbeddingIdReindex = (
  embeddingId: string,
  body: MlReindexEmbeddingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionEmbeddingsByEmbeddingIdReindex,
  method: httpMethod.post,
  url: `/API/ml/v1/face_recognition/embeddings/${encodeURIComponent(embeddingId)}/reindex/`,
  params: { embeddingId },
  body,
  headers,
});

export interface MlHttpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionIdQuery {
  /**
   * The profile to use for face image analysis (default is used if not specified)
   */
  face_image_analysis_profile_id?: string;
  /**
   * The profile to use for face video analysis (default is used if not specified)
   */
  face_video_analysis_profile_id?: string;
  /**
   * If true, run faces recognition again even if persons already exist on asset
   */
  force?: boolean;
}

/**
 * `POST /v1/face_recognition/extract/assets/{asset_id}/versions/{version_id}/`
 *
 * Extract face images and face data for an asset
 *
 * Required roles:
 *  - can_trigger_face_recognition
 *
 * Responses
 * - 202 - Process started
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Face recognition is not enabled for this system domain
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_extract_assets__asset_id__versions__version_id__}
 */
export const httpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionId =
  (
    assetId: string,
    versionId: string,
    query?: MlHttpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionIdQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: MlHttpPostFaceRecognitionExtractAssetsByAssetIdVersionsByVersionId,
    method: httpMethod.post,
    url: `/API/ml/v1/face_recognition/extract/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
    params: { assetId, versionId },
    query,
    headers,
  });

/**
 * `PUT /v1/face_recognition/jobs/priority/`
 *
 * Bulk-change priority of FR jobs
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 202 - task scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/put_v1_face_recognition_jobs_priority_}
 */
export const httpPutFaceRecognitionJobsPriority = (
  body: MlJobsPrioritySchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPutFaceRecognitionJobsPriority,
  method: httpMethod.put,
  url: '/API/ml/v1/face_recognition/jobs/priority/',

  body,
  headers,
});

/**
 * `PUT /v1/face_recognition/jobs/state/`
 *
 * Bulk-abort / restart FR extraction jobs
 *
 * Required roles:
 *  - can_write_jobs
 *
 * Responses
 * - 202 - task scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/put_v1_face_recognition_jobs_state_}
 */
export const httpPutFaceRecognitionJobsState = (
  body: MlJobsStateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPutFaceRecognitionJobsState,
  method: httpMethod.put,
  url: '/API/ml/v1/face_recognition/jobs/state/',

  body,
  headers,
});

export interface MlHttpGetFaceRecognitionPersonsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * If true passed then uses scroll pagination instead of default one
   */
  scroll?: boolean;
  /**
   * In order to get next batch of results using scroll pagination the scroll_id is required
   */
  scroll_id?: string;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc
   */
  sort?: string;
  /**
   * Filter by status; NEW, UNCONFIRMED, USER_CONFIRMED or SYSTEM_CONFIRMED
   */
  status?: string;
  /**
   * Filter by name (can use wildcard search e.g. *doe*)
   */
  name?: string;
  /**
   * Filter by multiple statuses. Comma separated list of statuses.
   */
  status_in?: string;
  /**
   * Filter by persons with or without name
   */
  has_name?: boolean;
}

/**
 * `GET /v1/face_recognition/persons/`
 *
 * Get all persons
 *
 * Required roles:
 *  - can_read_person
 *
 * Responses
 * - 200 - Returns the list of persons
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/get_v1_face_recognition_persons_}
 */
export const httpGetFaceRecognitionPersons = (
  query?: MlHttpGetFaceRecognitionPersonsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpGetFaceRecognitionPersons,
  method: httpMethod.get,
  url: '/API/ml/v1/face_recognition/persons/',

  query,
  headers,
});

/**
 * `DELETE /v1/face_recognition/persons/bulk_delete/`
 *
 * Bulk delete multiple persons by ID
 *
 * Required roles:
 *  - can_delete_person
 *
 * Responses
 * - 201 - Returns the definition of the created job of deleting multiple persons in bulk
 * - 400 - Bad request or an invalid UUID
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/delete_v1_face_recognition_persons_bulk_delete_}
 */
export const httpDeleteFaceRecognitionPersonsBulkDelete = (
  body: MlBulkDeletePersonsByIdsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpDeleteFaceRecognitionPersonsBulkDelete,
  method: httpMethod.delete,
  url: '/API/ml/v1/face_recognition/persons/bulk_delete/',

  body,
  headers,
});

export interface MlHttpPostFaceRecognitionPersonsReindexQuery {
  /**
   * Whether to sync person data to the Assets index. Defaults to false.
   */
  sync_assets?: boolean;
  /**
   * Whether to use low priority indexing. Defaults to false.
   */
  low_priority_indexing?: boolean;
}

/**
 * `POST /v1/face_recognition/persons/reindex/`
 *
 * Trigger reindexing of persons by IDs
 *
 * Required roles:
 *  - can_reindex_person
 *
 * Responses
 * - 202 - Persons scheduled for reindexing
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons_reindex_}
 */
export const httpPostFaceRecognitionPersonsReindex = (
  body: MlBulkReindexPersonsSchema,
  query?: MlHttpPostFaceRecognitionPersonsReindexQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionPersonsReindex,
  method: httpMethod.post,
  url: '/API/ml/v1/face_recognition/persons/reindex/',

  body,
  query,
  headers,
});

/**
 * `DELETE /v1/face_recognition/persons/{person_id}/`
 *
 * Delete a person
 *
 * Required roles:
 *  - can_delete_person
 *
 * Responses
 * - 201 - Returns the definition of the created job of deleting a person
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/delete_v1_face_recognition_persons__person_id__}
 */
export const httpDeleteFaceRecognitionPersonsByPersonId = (
  personId: string,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpDeleteFaceRecognitionPersonsByPersonId,
  method: httpMethod.delete,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/`,
  params: { personId },
  headers,
});

/**
 * `GET /v1/face_recognition/persons/{person_id}/`
 *
 * Get a single person by ID
 *
 * Required roles:
 *  - can_read_person
 *
 * Responses
 * - 200 - Returns a single person
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/get_v1_face_recognition_persons__person_id__}
 */
export const httpGetFaceRecognitionPersonsByPersonId = (
  personId: string,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpGetFaceRecognitionPersonsByPersonId,
  method: httpMethod.get,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/`,
  params: { personId },
  headers,
});

export type MlUpdatePersonSchemaPartial = Partial<MlUpdatePersonSchema>;

/**
 * `PATCH /v1/face_recognition/persons/{person_id}/`
 *
 * Update an existing person
 *
 * Required roles:
 *  - can_edit_person
 *
 * Responses
 * - 200 - Person updated successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/patch_v1_face_recognition_persons__person_id__}
 */
export const httpPatchFaceRecognitionPersonsByPersonId = (
  personId: string,
  body: MlUpdatePersonSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPatchFaceRecognitionPersonsByPersonId,
  method: httpMethod.patch,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/`,
  params: { personId },
  body,
  headers,
});

/**
 * `PUT /v1/face_recognition/persons/{person_id}/`
 *
 * Update an existing person
 *
 * Required roles:
 *  - can_edit_person
 *
 * Responses
 * - 200 - Person updated successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/put_v1_face_recognition_persons__person_id__}
 */
export const httpPutFaceRecognitionPersonsByPersonId = (
  personId: string,
  body: MlUpdatePersonSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPutFaceRecognitionPersonsByPersonId,
  method: httpMethod.put,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/`,
  params: { personId },
  body,
  headers,
});

/**
 * `DELETE /v1/face_recognition/persons/{person_id}/assets/{asset_id}/versions/{version_id}/`
 *
 * Delete a person from an asset version
 *
 * Required roles:
 *  - can_delete_person
 *
 * Responses
 * - 204 - Person deleted successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/delete_v1_face_recognition_persons__person_id__assets__asset_id__versions__version_id__}
 */
export const httpDeleteFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionId =
  (
    personId: string,
    assetId: string,
    versionId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: MlHttpDeleteFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionId,
    method: httpMethod.delete,
    url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/`,
    params: { personId, assetId, versionId },
    headers,
  });

/**
 * `POST /v1/face_recognition/persons/{person_id}/assets/{asset_id}/versions/{version_id}/change_person/`
 *
 * Change a person asset version instance to another person
 *
 * Required roles:
 *  - can_delete_person
 * - can_edit_person
 * - can_add_person
 *
 * Responses
 * - 201 - Person change scheduled successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonByAssetAndVersionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__assets__asset_id__versions__version_id__change_person_}
 */
export const httpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdChangePerson =
  (
    personId: string,
    assetId: string,
    versionId: string,
    body: MlChangePersonInstanceSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdChangePerson,
    method: httpMethod.post,
    url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/change_person/`,
    params: { personId, assetId, versionId },
    body,
    headers,
  });

export interface MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPersonQuery {
  /**
   * Whether to use the instance face as main face or not
   */
  use_instance_as_main_face?: boolean;
}

/**
 * `POST /v1/face_recognition/persons/{person_id}/assets/{asset_id}/versions/{version_id}/confirm_person/`
 *
 * Confirm a system unconfirmed person instance
 *
 * Required roles:
 *  - can_delete_person
 * - can_edit_person
 *
 * Responses
 * - 200 - Person updated successfully
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonByAssetAndVersionSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__assets__asset_id__versions__version_id__confirm_person_}
 */
export const httpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPerson =
  (
    personId: string,
    assetId: string,
    versionId: string,
    query?: MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPersonQuery,
    headers?: IconikApiHeaders,
  ) => ({
    id: MlHttpPostFaceRecognitionPersonsByPersonIdAssetsByAssetIdVersionsByVersionIdConfirmPerson,
    method: httpMethod.post,
    url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/confirm_person/`,
    params: { personId, assetId, versionId },
    query,
    headers,
  });

/**
 * `DELETE /v1/face_recognition/persons/{person_id}/bulk/`
 *
 * Delete a persons's instances in bulk
 *
 * Required roles:
 *  - can_delete_person
 *
 * Responses
 * - 201 - Returns the definition of the created job of deleting person instances
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/delete_v1_face_recognition_persons__person_id__bulk_}
 */
export const httpDeleteFaceRecognitionPersonsByPersonIdBulk = (
  personId: string,
  body: MlBulkDeletePersonsSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpDeleteFaceRecognitionPersonsByPersonIdBulk,
  method: httpMethod.delete,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/bulk/`,
  params: { personId },
  body,
  headers,
});

/**
 * `POST /v1/face_recognition/persons/{person_id}/confirm_person/`
 *
 * Confirms multiple person instances in bulk
 *
 * Required roles:
 *  - can_delete_person
 * - can_edit_person
 *
 * Responses
 * - 204 - Person instances successfully scheduled for confirmation
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__confirm_person_}
 */
export const httpPostFaceRecognitionPersonsByPersonIdConfirmPerson = (
  personId: string,
  body: MlBulkConfirmPersonSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionPersonsByPersonIdConfirmPerson,
  method: httpMethod.post,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/confirm_person/`,
  params: { personId },
  body,
  headers,
});

export interface MlHttpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrlQuery {
  storage_id?: string;
}

/**
 * `GET /v1/face_recognition/persons/{person_id}/faces/{face_id}/image_url/`
 *
 * Get a presigned URL for a face image
 *
 *
 * Responses
 * - 200 - Returns the presigned URL
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MlURLSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/get_v1_face_recognition_persons__person_id__faces__face_id__image_url_}
 */
export const httpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrl = (
  personId: string,
  faceId: string,
  query?: MlHttpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrlQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpGetFaceRecognitionPersonsByPersonIdFacesByFaceIdImageUrl,
  method: httpMethod.get,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/faces/${encodeURIComponent(faceId)}/image_url/`,
  params: { personId, faceId },
  query,
  headers,
});

/**
 * `POST /v1/face_recognition/persons/{person_id}/merge/{new_person_id}/`
 *
 * Change an existing person to another person
 *
 * Required roles:
 *  - can_delete_person
 * - can_edit_person
 * - can_add_person
 *
 * Responses
 * - 201 - Returns the definition of the created job of changing a person
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__merge__new_person_id__}
 */
export const httpPostFaceRecognitionPersonsByPersonIdMergeByNewPersonId = (
  personId: string,
  newPersonId: string,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionPersonsByPersonIdMergeByNewPersonId,
  method: httpMethod.post,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/merge/${encodeURIComponent(newPersonId)}/`,
  params: { personId, newPersonId },
  headers,
});

export interface MlHttpPostFaceRecognitionPersonsByPersonIdReindexQuery {
  /**
   * Whether to sync person data to the Assets index. Defaults to true.
   */
  sync_assets?: boolean;
  /**
   * Whether to use low priority indexing. Defaults to false.
   */
  low_priority_indexing?: boolean;
}

/**
 * `POST /v1/face_recognition/persons/{person_id}/reindex/`
 *
 * Reindex person
 *
 * Required roles:
 *  - can_reindex_person
 *
 * Responses
 * - 202 - Person scheduled for reindexing
 * - 401 - Token is invalid
 * - 404 - person does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__reindex_}
 */
export const httpPostFaceRecognitionPersonsByPersonIdReindex = (
  personId: string,
  body: MlReindexPersonSchema,
  query?: MlHttpPostFaceRecognitionPersonsByPersonIdReindexQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionPersonsByPersonIdReindex,
  method: httpMethod.post,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/reindex/`,
  params: { personId },
  body,
  query,
  headers,
});

/**
 * `POST /v1/face_recognition/persons/{person_id}/update_and_confirm/`
 *
 * Updates person with name and confirms instances in bulk
 *
 * Required roles:
 *  - can_delete_person
 * - can_edit_person
 *
 * Responses
 * - 200 - Person updated and instances successfully scheduled for confirmation
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Person not found
 *
 * Response {@link MlPersonSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/post_v1_face_recognition_persons__person_id__update_and_confirm_}
 */
export const httpPostFaceRecognitionPersonsByPersonIdUpdateAndConfirm = (
  personId: string,
  body: MlUpdateConfirmPersonSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpPostFaceRecognitionPersonsByPersonIdUpdateAndConfirm,
  method: httpMethod.post,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/update_and_confirm/`,
  params: { personId },
  body,
  headers,
});

export interface MlHttpGetFaceRecognitionPersonsByPersonIdVersionsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * Whether to include admin details in the response or not
   */
  include_admin_details?: boolean;
  /**
   * Whether to use the instance face as main face or not
   */
  use_instance_as_main_face?: boolean;
}

/**
 * `GET /v1/face_recognition/persons/{person_id}/versions/`
 *
 * List all person_id instances across assets versions
 *
 * Required roles:
 *  - can_read_person
 *
 * Responses
 * - 200 - Returns a list of persons by asset and version
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MlPersonAssetsVersionsListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/ml/spec/#/default/get_v1_face_recognition_persons__person_id__versions_}
 */
export const httpGetFaceRecognitionPersonsByPersonIdVersions = (
  personId: string,
  query?: MlHttpGetFaceRecognitionPersonsByPersonIdVersionsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MlHttpGetFaceRecognitionPersonsByPersonIdVersions,
  method: httpMethod.get,
  url: `/API/ml/v1/face_recognition/persons/${encodeURIComponent(personId)}/versions/`,
  params: { personId },
  query,
  headers,
});
